import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { KSK2090_R01DetailDto, KSK2090_R01Dto, KSK2090_R01HeaderDto } from './Dto_KSK2090_R01';
import { KSK2090_R01Filter } from "./Store_KSK2090_R01";

const baseUrl = `${config.apiUrl}/KSK2090_R01`;

const getParams = (filter: Partial<KSK2090_R01Filter>, listLength?: number) => {	
	return {
		prntItemcd: filter.prntItemcd || '',
		listLength: listLength || 0
	}
}

export const getKSK2090_R01List = async (option: string, params: Partial<KSK2090_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<KSK2090_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getKSK2090_R01AllCount = async (params: Partial<KSK2090_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getKSK2090_R01DetailList = async (prntItemcd: string) => {
	const url = `${baseUrl}/detail/${prntItemcd}`;

	return await getData<ResponseDto<KSK2090_R01DetailDto[]>>(url);
}

export const postKSK2090_R01 = async (data: KSK2090_R01DetailDto[]) => {
	const url = `${baseUrl}`;

	return await postData<KSK2090_R01DetailDto[], ResponseDto<KSK2090_R01Dto[]>>(url, data);
}

export const patchKSK2090_R01 = async (data: KSK2090_R01DetailDto[]) => {

	const url = `${baseUrl}`;

	return await patchData<KSK2090_R01DetailDto[], ResponseDto<KSK2090_R01Dto[]>>(url, data);
}

export const deleteKSK2090_R01 = async (coordinateCd: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			coordinateCd
		}
	});
}

export const downloadExcel_KSK2090_R01 = async (option: string, itemCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			itemCd
		}
	})
}
export const printKSK2090_R01 = async (itemCd: string) => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { itemCd },
		responseType: "blob",
	});
	const fileBlob = new Blob([response.data], { type: "application/pdf" });
	const fileURL = URL.createObjectURL(fileBlob);
	window.open(fileURL, "_blank");
	};